module.exports = __webpack_public_path__ + "static/media/france_flag.43b3f7cf.png";